<svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    id="svg12"
    version="1.1"
    viewBox="0 0 20 20"
    height="20"
    width="20"
    aria-labelledby="save-icon-title save-icon-desc"
    role="img"
>
    <title id="save-icon-title">Save icon</title>
    <desc id="save-icon-desc">This is a floppy disk icon depicting save.</desc>
    <defs id="defs16" />
    <g
        transform="translate(0,-15)"
        style="fill:none;fill-rule:evenodd"
        id="g10"
    >
        <path
            class="fill"
            fill="#26478d"
            id="path8"
            d="m 13.043,20.217001 c 0.24,0 0.435,-0.194 0.435,-0.434 v -2.61 c 0,-0.24 -0.194,-0.434 -0.435,-0.434 -0.24,0 -0.434,0.194 -0.434,0.435 v 2.609 c 0,0.24 0.194,0.434 0.434,0.434 z M 19.13,33.261 c 0,0.48 -0.39,0.87 -0.87,0.87 h -0.869 v -8.479 c 0,-0.6 -0.487,-1.087 -1.087,-1.087 H 3.696 c -0.6,0 -1.087,0.488 -1.087,1.087 v 8.478 h -0.87 c -0.48,0 -0.87,-0.39 -0.87,-0.87 V 16.740001 C 0.869,16.26 1.259,15.87 1.739,15.87 h 1.74 v 5.000001 c 0,0.6 0.487,1.087 1.086,1.087 h 10.87 c 0.6,0 1.087,-0.488 1.087,-1.087 V 15.87 h 0.087 c 0.14,0 0.27,0.054 0.369,0.153 l 2,2.000001 c 0.098,0.098 0.152,0.229 0.152,0.368 z m -2.608,0.87 H 3.478 v -8.479 c 0,-0.12 0.098,-0.217 0.218,-0.217 h 12.608 c 0.12,0 0.218,0.098 0.218,0.217 V 34.13 Z M 4.348,15.87 h 11.304 v 5.000001 c 0,0.12 -0.098,0.217 -0.217,0.217 H 4.565 c -0.12,0 -0.217,-0.098 -0.217,-0.217 z m 15.245,1.537001 -2,-2.000001 C 17.33,15.146 16.98,15 16.609,15 H 1.739 C 0.78,15 0,15.78 0,16.740001 V 33.26 C 0,34.22 0.78,35 1.74,35 H 18.26 C 19.22,35 20,34.22 20,33.26 V 18.392001 c 0,-0.371 -0.145,-0.72 -0.407,-0.984 z"
        />
    </g>
</svg>
